import { Globe, Euro, Edit2, Landmark, ExternalLink, ArrowLeft } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { 
  ChangelogViewer, 
  ResetCustomizations 
} from "@/components/CountryEditor";

export default function CountryHeader({ country, countryCode, onBack, onRefresh }) {
  return (
    <>
      {/* Back Button */}
      <div className="flex items-center gap-3 mb-3">
        <Button onClick={onBack} variant="ghost" size="sm" data-testid="back-to-countries-btn">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back
        </Button>
      </div>

      {/* Country Header */}
      <div className="card p-4 mb-4">
        <div className="flex flex-col md:flex-row md:items-center gap-3">
          <span className="text-4xl">{country.flag_emoji}</span>
          <div className="flex-1 min-w-0">
            <h1 className="text-xl font-bold text-zinc-800">{country.country_name}</h1>
            <div className="flex flex-wrap gap-2 mt-1.5">
              <Badge variant="outline" className="gap-1 text-xs">
                <Globe className="w-3 h-3" /> {country.country_code}
              </Badge>
              <Badge variant="outline" className="gap-1 text-xs">
                <Euro className="w-3 h-3" /> {country.currency}
              </Badge>
              <Badge variant="secondary" className="text-xs">{country.language}</Badge>
              {country.has_customizations && (
                <Badge className="bg-violet-100 text-violet-700 text-xs">
                  <Edit2 className="w-3 h-3 mr-1" /> Customized
                </Badge>
              )}
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <ChangelogViewer countryCode={countryCode} />
            {country.has_customizations && (
              <ResetCustomizations countryCode={countryCode} onReset={onRefresh} />
            )}
            {country.regulatory_authority && (
              <a 
                href={country.regulatory_authority.website} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-secondary text-xs"
                data-testid="regulatory-authority-link"
              >
                <Landmark className="w-3.5 h-3.5" />
                <span className="hidden sm:inline">{country.regulatory_authority.name}</span>
                <ExternalLink className="w-3 h-3" />
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
